module.exports = __webpack_public_path__ + "img/shoplogo.17283f7a.svg";